import { ObjectMapper } from 'json-object-mapper';
import { Model } from '../../model';
import { IModel } from '../../IModel';
import { PetitionsStatusEnum } from 'services/enums/petitionsStatus.enum';
import { PetitionsRequestTypeEnum } from 'services/enums/petitionsRequestType.enum';
import { BenefitTypeEnum } from 'services/enums/benefitsType.enum';
import { BenefitPetitionDependentModel } from './benefitPetitionDependent.model';

export class BenefitPetitionModel extends Model implements IModel<BenefitPetitionModel> {
  benefiDescription: string = '';
  benefitEmployeeId: string | undefined = undefined;
  benefitPetitionDependent: BenefitPetitionDependentModel[] = [];
  benefitPlanId: string | undefined = undefined;
  benefitType: string = '';
  employeeId: string | undefined = undefined;
  employeeJobTitle: string = '';
  employeeName: string = '';
  providerId: string | undefined = undefined;
  providerLogo: string = '';
  providerName: string = '';
  requestType: string = '';
  status: string = '';
  benefitId: string | undefined = undefined;

  get statusBadge(): string {
    const status = PetitionsStatusEnum.getBy(this.status);
    return `<span class="badge bg-${status?.className} rounded-pill text-wrap">${status?.label}</span>`;
  }

  get customizeEmployee(): string {
    return `<b class="text-primary">${this.employeeName}</b><br>${this.employeeJobTitle}`;
  }

  get requestTypeBadge(): string {
    const status = PetitionsRequestTypeEnum.getBy(this.requestType);
    return `<span class="badge badge-pill badge-light-${status?.className} rounded-pill text-wrap">${status?.label}</span>`;
  }

  get benefitTypeLabel(): string {
    return BenefitTypeEnum.getBy(this.benefitType).label;
  }

  get requestTypeLabel(): string {
    return PetitionsRequestTypeEnum.getBy(this.requestType).label;
  }

  get statusLabel(): string {
    return PetitionsStatusEnum.getBy(this.status).label;
  }

  static create(input: any): BenefitPetitionModel {
    if ('benefitPetitionDependent' in input) {
      input.benefitPetitionDependent = input.benefitPetitionDependent.map(
        BenefitPetitionDependentModel.create
      );
    }

    return ObjectMapper.deserialize<BenefitPetitionModel>(BenefitPetitionModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
